import React from 'react';

const Header = () => {
  return (
    <div>
      <header>
        <h3> Keep Notes </h3>
      </header>
    </div>
  );
};

export default Header;
